import React, { useState, useEffect } from 'react'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
// import SearchIcon from '@material-ui/icons/SearchOutlined'
// import XIcon from '@material-ui/icons/CloseOutlined'
import ReportItem from './Components/ReportItem'
import { AnalyticEvent } from '../analytics/GoogleAnalytics'
import { getReports, createReport } from './Store/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import CreateReport from './Modals/CreateReport'
import Snackbar from '../UI/Snackbar'
import TableTopSection from 'UI/TableTopSection'

const Reports = props => {
  // const [searchValue, setSearchValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')
  const [searchFilter, setSearchFilter] = useState(false)
  const [reportList, setReportList] = useState(props.reports.reportList)

  const [createReportModal, setCreateReportModal] = useState(false)

  const loadAllReports = () => {
    setReportList(props.reports.reportList)
  }

  const handleCreateReport = payload => {
    props.setSnackBarCopy('New Report Created')
    props.createReport({ ...payload, createdBy: props.userName })
    loadAllReports()
    handleSnackBar()
  }

  const createReportModalToggle = () => {
    setCreateReportModal(!createReportModal)
  }

  const handleSnackBar = () => {
    props.toggleSnackBar(true)
    setTimeout(() => {
      props.toggleSnackBar(false)
    }, 2500)
  }

  useEffect(() => {
    props.getReports(true)
    loadAllReports()
  }, [props.loading]) //eslint-disable-line

  return (
    <MainContainer>
      {/* <form onSubmit={e => console.log(e)}>
              <TextField
                rightEl={searchValue.length > 0 ? <XIcon onClick={undefined} /> : <SearchIcon />}
                placeholder="Search"
                onChange={e => setSearchValue(e.target.value)}
                value={searchValue}
                className="halfWidthInputBox"
                wrapperProps={{ style: { marginRight: '10px' } }}
              />
            </form> */}

      <TableContainer>
        <TableTopSection
          title="Reports"
          loading={props.loading}
          // searchString={
          //   !props.loading ? (
          //     <ReportNumText>
          //       {!searchFilter &&
          //         props.reports.reportList &&
          //         searchedValue.length === 0 &&
          //         `${props.reports.reportList.length} Reports`}
          //       {!props.reports.reportList && `0 Reports`}
          //       {searchFilter &&
          //         `${reportList.length}  ${
          //           reportList.length > 1 ? 'Reports' : 'Report'
          //         } found for '${searchedValue}'`}
          //     </ReportNumText>
          //   ) : (
          //     undefined
          //   )
          // }
          // searchSubmit={e => search(e)}
          // searchXButtonPress={clearSearch}
          // searchValue={searchValue}
          // setSearchValue={v => setSearchValue(v)}
          handlePlusIconClick={createReportModalToggle}
          sear
        />

        <TableSection>
          <thead>
            <tr>
              {['NAME', 'CREATED ON', 'CREATED BY', 'SYSTEM NOTES', ''].map((item, i) => (
                <TableHeader title={item} key={i} />
              ))}
            </tr>
          </thead>
          <tbody>
            {!props.reports.loading &&
              props.reports.reportList &&
              props.reports.reportList.map((report, index) => {
                return (
                  <ReportItem report={report} key={index} history={props.history} index={index} />
                )
              })}
          </tbody>
        </TableSection>
      </TableContainer>
      {//modals
      createReportModal && (
        <CreateReport
          createReportModalToggle={createReportModalToggle}
          projects={props.projects}
          hauls={props.hauls}
          sites={props.sites}
          drivers={props.drivers}
          createReport={handleCreateReport}
          getReports={props.getReports}
        />
      )}

      {props.snackBarVisible && <Snackbar text={props.snackBarCopy} />}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    reports: state.reports,
    projects: state.projects.projectList,
    hauls: state.hauls.haulList,
    sites: state.sites.siteList,
    drivers: state.drivers.driverList,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    loading: state.reports.loading,
    userName: `${state.user.userData.firstName} ${state.user.userData.lastName}`
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getReports,
      createReport,
      setSnackBarCopy,
      toggleSnackBar
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
